module.exports = __webpack_public_path__ + "media/theme/step--3--open-3125b220.png";